module.exports = __webpack_public_path__ + "static/media/cgc-logo.803eb300.png";